import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";

function api() {
  return {
    getList: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get("/conductor", {
        params: params
      });
    },

    create: (data: RequestData) => {
      const {payload} = data;
      return HttpRequest.post('conductor', payload, {});
    },

    update: (data: RequestData) => {
      const {params = {}, payload} = data;
      return HttpRequest.post(`conductor/${params.conductor_id}`, payload, {});
    },

    delete: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.delete(`conductor/${params.conductor_id}`, {});
    },

    getItem: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`conductor/${params.conductor_id}`);
    },

    autoConductor: (id: string) => {
      return HttpRequest.get(`conductor/${id}/stream/auto`);
    },

    pauseConductor: (id: string) => {
      return HttpRequest.get(`conductor/${id}/stream/pause`);
    },

    startConductor: (id: string) => {
      return HttpRequest.get(`conductor/${id}/stream/start`);
    },

    endConductor: (id: string) => {
      return HttpRequest.get(`conductor/${id}/stream/end`);
    },

    resumeConductor: (id: string) => {
      return HttpRequest.get(`conductor/${id}/stream/resume`);
    },

    interruptConductor: (id: string) => {
      return HttpRequest.get(`conductor/${id}/stream/interrupt`);
    },
  };
}

export default api();
